import {
  useGetMyProfileQuery as useGetMyProfile,
  GetMyProfileQuery as MyProfileType,
} from '../../generated/graphql';

export type { MyProfileType };
export default useGetMyProfile;
